// Above this threshold, a loading indicator should be shown.
export const THRESHOLD_LOADING = Temporal.Duration.from({ milliseconds: 200 });

// Above this threshold, a progress indicator should be shown.
export const THRESHOLD_PROGRESS = Temporal.Duration.from({ seconds: 5 });
